import moment from 'moment/moment';
import { AuditLog } from '@/models/logs/AuditLog';
import { FamilyMembersLogs } from '@/enums/FamilyMembersLogs';
import { FacilitySettingsModel } from '@/models/FacilitySettings';
import { FamilyMemberLog } from '@/models/logs/FamilyMemberLogs';

export default {
  name: 'FamilyLogs',
  filters: {
    capitalize(value) {
      if (!value) return "";
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatedData(data) {
      if (!data) return "";
      const sensitiveData: string[] = [
        "setPasswordToken",
        "unsubscribeFromEmailsToken"
      ]

      const result = Object.entries(data)
        .flatMap(([key, value]) => {
          if (!value || typeof value !== "object") return [];

          let { before, after } = value as { before?: any; after?: any };

          if (before?.hasOwnProperty("seconds")) {
            before = moment(before.seconds * 1000).format("YYYY-MM-DD HH:mm:ss");
          }
          if (after?.hasOwnProperty("seconds")) {
            after = moment(after.seconds * 1000).format("YYYY-MM-DD HH:mm:ss");
          }

          if (before == null && after == null) return [];

          const fieldKey = key.split(".").pop()?.replace(/\[[^\]]*\]/g, "");

          const label = fieldKey
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/Iso/gi, "")
            .replace(/\s+/g, " ")
            .trim()
            .replace(/^./, str => str.toUpperCase());

          const entries: { label: string; value: string }[] = [];

          if (after != null) {
            entries.push({
              label,
              value: sensitiveData.includes(key) ? "********" : after,
            });
          }

          if (before != null) {
            entries.push({
              label: `${label} (old)`,
              value: sensitiveData.includes(key) ? "********" : before,
            });
          }

          return entries;
        });

      return result.map(entry => `${entry.label}: ${JSON.stringify(entry.value)}`).join("\n");
    }
  },
  data() {
    return {
      search: "",
      types: [],
      loading: false,
      startDatePicker: {
        menu: false,
        date: moment().subtract("month", 1).format('YYYY-MM-DD')
      },
      endDatePicker: {
        menu: false,
        date: moment().format('YYYY-MM-DD')
      },
      headers: [
        {
          text: this.$t('FamilLogs.FamilyMemberName'),
          align: "start",
          value: "initiatorName",
          width: 200,
        },
        {
          text: this.$t('FamilLogs.EPOA'),
          align: "start",
          value: "initiatorEPOA",
          width: 120,
        },
        {
          text: this.$t('FamilLogs.Resident'),
          align: "start",
          value: "initiatorResidents",
          width: 300,
        },
        {
          text: this.$t('FamilLogs.Date'),
          align: "start",
          value: "timestamp",
          width: 200,
        },
        {
          text: this.$t('FamilLogs.Actions'),
          align: "start",
          value: "typesOfRecordChanged",
          width: 200,
        },
      ],
    }
  },
  computed: {
    facility(): FacilitySettingsModel {
      return this.$store.state.facilityModule.selectedFacility;
    },
    familyMembersAuditLogs(): AuditLog[] {
      return this.$store.state.auditLogsModule.familyMembersAuditLogs;
    },
    familyMembersCareLogs(): AuditLog[] {
      return this.$store.state.auditLogsModule.familyMembersCareLogs;
    },
    allFamilyMembersLogs(): FamilyMemberLog[] {
      const auditMapped = this.familyMembersAuditLogs.map(this.mapLog);
      const careMapped = this.familyMembersCareLogs.map(this.mapLog);
      
      const combined = [...auditMapped, ...careMapped];
      
      return combined.sort((a, b) => {
        const dateA = (a.timestamp as firebase.firestore.Timestamp).toDate();
        const dateB = (b.timestamp as firebase.firestore.Timestamp).toDate();

        return dateB.getTime() - dateA.getTime();
      });
    },
    filteredFamilyMembersLogs(): FamilyMemberLog[] {
      const query = this.search.trim().toLowerCase();
      const hasSearch = query.length > 0;
      const hasTypesFilter = this.types.length > 0;

      return this.allFamilyMembersLogs.filter((item: AuditLog) => {
        const matchesName = hasSearch ? item.initiatorName.toLowerCase().includes(query) : true;
        const hasAllowedType = hasTypesFilter ? item.typesOfRecordChanged.some((type: string) => this.types.includes(type)) : true;

        return matchesName && hasAllowedType;
      });
    },
    recordsTypes(): Array<string> {
      return Object.values(FamilyMembersLogs);
    },
  },
  async created() {
    await this.getFamilyMembersLogs();
  },
  methods: {
    async getFamilyMembersLogs() {
      this.loading = true;

      // Only fetch careLogs (not other audit logs)
      await this.$store.dispatch("getFamilyMembersAuditLogs", {
        startDate: moment(this.startDatePicker.date).startOf('day').toDate(),
        endDate: moment(this.endDatePicker.date).endOf('day').toDate(),
      });


      this.loading = false;
    },
    mapLog(log): FamilyMemberLog {
      return {
        id: log.id,
        initiatorName: log.initiatorName,
        initiatorEPOA: log.initiatorEPOA,
        initiatorResidents: log.initiatorResidents,
        timestamp: log.timestamp ?? log.dateTime,
        typesOfRecordChanged: log.typesOfRecordChanged,
        source: log.source,
      };
    }
  }
}